import { render, staticRenderFns } from "./OtherInstitute.vue?vue&type=template&id=0ea9a50e"
import script from "./OtherInstitute.vue?vue&type=script&lang=js"
export * from "./OtherInstitute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports